<template>
    <div class="b">
      jjj
    </div>
</template>

<script>
    export default {
        name: "jj"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/jj/src/jj.vue